import { useState } from 'react'
import { SiteMetaData, CategoryFilterKey } from '../types'

interface CategoryFilter<T extends CategoryFilterKey> {
    key: T
    values: readonly SiteMetaData[T][]
}

type SiteCategoryFilters = CategoryFilter<CategoryFilterKey>[]

const filterSites = <T extends SiteMetaData = SiteMetaData>(sites: T[], filters: SiteCategoryFilters): T[] =>
    sites.filter((site) =>
        filters.every((filter) => filter.values.length === 0 || filter.values.includes(site[filter.key]))
    )

// @TODO : use search query instead of state
export const useSiteFilters = () => {
    const [categoryFilters, setCategoryFilters] = useState<SiteCategoryFilters>([])

    const addFilter = <T extends CategoryFilterKey>(key: T) => {
        if (categoryFilters.some((filter) => filter.key === key)) return
        setCategoryFilters([...categoryFilters, { key, values: [] }])
    }
    const removeFilter = <T extends CategoryFilterKey>(key: T) => {
        setCategoryFilters(categoryFilters.filter((filter) => filter.key !== key))
    }
    const updateFilterValues = <T extends CategoryFilterKey>(key: T, values: SiteMetaData[T][]) => {
        setCategoryFilters(
            categoryFilters.map((filter) => {
                if (filter.key === key) {
                    return { ...filter, values }
                }
                return filter
            })
        )
    }
    return {
        filters: categoryFilters,
        addFilter,
        removeFilter,
        updateFilterValues,
        filterSites: <T extends SiteMetaData>(sites: T[]) => filterSites(sites, categoryFilters),
    }
}
